/* istanbul ignore file */
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing } = themeVariables;

export const root = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.xs});
  justify-content: center;
  margin-top: var(${spacing.md});
`;

export const dot = css`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(${colors.content.tertiary});
  opacity: 0.4;

  &[data-active='true'] {
    opacity: 1;
  }
`;
